import { Grid2 } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import logo from "../../../../assets/logos/admin_logo.svg";
import DrugOrderConfirmLotTable from "../../../../components/DrugOrderConfirmLotTable/DrugOrderConfirmLotTable";
import DrugOrderConfirmSequenceTable from "../../../../components/DrugOrderConfirmSequenceTable/DrugOrderConfirmSequenceTable";
import { formatDateString } from "../../../../utilities/helper";

const OrderConfirmation = ({ setShowConfirm, data, resetDetails }) => {
  const navigate = useNavigate();

  const fields = [
    { label: "Order Number", key: "orderNumber" },
    { label: "Order Type", key: "orderType" },
    { label: "Date", key: "orderDate" },
  ];

  const email = localStorage.getItem("email");
  return (
    <>
      <div className="content-body">
        <p
          className="bread-crumbs-link-container"
          style={{ fontWeight: "600" }}
        >
          <Link className="bread-crumbs-link" to="/">
            Home
          </Link>{" "}
          |{" "}
          <Link
            className="bread-crumbs-link"
            to="/drug-shipment-management"
            onClick={() => {
              setShowConfirm(false);
              resetDetails();
            }}
          >
            Drug Order Management
          </Link>
          | <Link className="bread-crumbs-link">Drug Order Confirmation</Link>-{" "}
          <b style={{ color: "gray" }}>
            {localStorage?.getItem("studyName")}
          </b>
        </p>
        <Grid2
          container
          alignItems="center"
          justifyContent="space-between"
          sx={{ width: "100%", margin: "0 auto" }}
        >
          <Grid2 item md={6}>
            <p className="page-heading">
              Dev-Genesis Base 3.1 Confirmation of Manual Order Request - Source{" "}
              {data?.sourceDepotName} - Destination{" "}
              {data?.destinationDepotName || data?.siteNumber}
            </p>
          </Grid2>
        </Grid2>
        <div className="heading-container">
          <h4>Confirmation of Manual Order Request Genesis Base 3.1</h4>
        </div>
        <div className="inner-heading-container">
          <img
            className="admin-logo logo-image"
            src={logo}
            alt="Genesis Logo"
          />
          <div className="data-block">
            <div className="data-inner-block">
              <span className="data-inner-block-text">User Name : </span>
              <span style={{ color: "white" }}> {email}</span>
            </div>

            <div className="data-block">
              <span className="data-inner-block-text">
                System Transaction Date :
              </span>
              <span style={{ color: "white" }}>
                {" "}
                {new Date().toLocaleDateString()}
              </span>
            </div>
            {data?.siteTransactionDate && (
              <div className="data-inner-block">
                <span className="data-inner-block-text">
                  Site Transaction Date :
                </span>
                <span style={{ color: "white" }}>
                  {" "}
                  {new Date().toLocaleDateString()}
                </span>
              </div>
            )}
          </div>
        </div>

        <div
          className="data-content-container"
          style={{ marginBottom: "-20px" }}
        >
          {fields.map(({ label, key }) => (
            <div className="data-content" key={key}>
              <span className="data-content-label">{label}:</span>
              <span
                className="data-content-value"
                style={{
                  width: "277px",
                }}
              >
                {label == "Date" ? formatDateString(data?.[key]) : data?.[key]}
              </span>
            </div>
          ))}
        </div>

        {data?.lotMethodDrugs && data?.lotMethodDrugs.length > 0 ? (
          <DrugOrderConfirmLotTable data={data?.lotMethodDrugs} />
        ) : (
          <DrugOrderConfirmSequenceTable
            data={data?.sequenceRangeMethodDrugs}
          />
        )}

        <div className="note-container">
          <span
            style={{
              fontWeight: "600",
              color: "#585858",
            }}
          >
            Note :
          </span>
          <span>
            This request for manual order(s) has been recorded successfully. Any
            orders generated are displayed above.
          </span>
        </div>
        <div
          style={{
            height: "20px",
          }}
        ></div>
        <div className="footer-container">
          <span>
            Genesis 2025-Please contact Genesis Support for assistance at
            Genesis.com/support
          </span>
        </div>
        <Grid2
          alignItems={"center"}
          justifyContent="center"
          container
          gap={3}
          sx={{ marginTop: "2%" }}
        >
          <Grid2 item md={6}>
            <button
              className="create-btn"
              onClick={() => {
                navigate("/");
              }}
            >
              Home
            </button>
          </Grid2>
        </Grid2>
      </div>
    </>
  );
};

export default OrderConfirmation;
